import type { FC } from 'react';
import { Route } from 'react-router';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { HydrogenShipperBookingDetails } from 'src/pages/h2/fcfs/shipper-bookings/details';
import { HydrogenShipperBookingOverview } from 'src/pages/h2/fcfs/shipper-bookings/overview';

export const HydrogenShipperBookings: FC = () => {
  return (
    <RootRoutes>
      <Route
        path="/h2/fcfs/shipper-bookings"
        element={<HydrogenShipperBookingOverview />}
      />
      <Route
        path="/h2/fcfs/shipper-bookings/:bookingProcessId"
        element={<HydrogenShipperBookingDetails />}
      />
      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
